<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
                <span><i class="text-muted bi bi-question-circle me-2"></i></span>
                <span class="text-muted text-xs">
                    Please provide accurate personal information. This information is used to verify your identity and
                    maintain communication throughout the application process.
                </span>
            </div>

            <div class="form-group mt-3">
                <!-- Transaction Type Section -->
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold">Transaction Type</h5>

                    <!-- Client Category -->
                    <label for="client_category" class="fw-bold text-xs text-start d-block">This transaction is for: <span class="text-danger">*</span></label>
                    <select v-model="client_category" class="form-select rounded-small shadow-sm w-100" 
                        id="client_category" required @change="handle_client_category_change">
                        <option value="" disabled selected>Select transaction type</option>
                        <option v-for="option in client_category_options" :key="option.value" :value="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_category" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_category }}
                    </small>
                </div>

                <div v-if="client_category === 'PRIVATE'">
                    <!-- Personal Details Section -->
                    <div class="mb-4 p-3 border rounded shadow-sm">
                        <h5 class="fw-bold">Personal Details</h5>
    
                        <!-- First Name -->
                        <label for="first_name" class="fw-bold text-xs text-start d-block">First Name <span class="text-danger">*</span></label>
                        <input v-model="first_name" type="text" class="form-control rounded-small shadow-sm w-100" 
                            id="first_name" placeholder="Enter your first name" required />
                        <small v-if="error_messages.first_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.first_name }}
                        </small>
    
                        <!-- Last Name -->
                        <label for="last_name" class="fw-bold text-xs text-start d-block mt-3">Last Name <span
                                class="text-danger">*</span></label>
                        <input v-model="last_name" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="last_name" placeholder="Enter your last name" required />
                        <small v-if="error_messages.last_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.last_name }}
                        </small>
    
                        <!-- Preferred Name -->
                        <label for="preferred_name" class="fw-bold text-xs text-start d-block mt-3">Preferred Name</label>
                        <input v-model="client_preferred_name" type="text"
                            class="form-control rounded-small shadow-sm w-100" id="preferred_name"
                            placeholder="Enter your preferred name" maxlength="50" />
                        <small v-if="error_messages.client_preferred_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_preferred_name }}
                        </small>
    
                        <!-- ID/Passport Number -->
                        <label for="id_number" class="fw-bold text-xs text-start d-block mt-3">ID/Passport Number <span
                                class="text-danger">*</span></label>
                        <input v-model="id_number" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="id_number" placeholder="Enter your ID or passport number" required :disabled="is_field_disabled.id_number"
                            @input="validate_id_number" />
                        <small v-if="error_messages.id_number" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.id_number }}
                        </small>
                        <small v-else-if="client_id_type === 'RSA ID'" class="form-text text-muted text-xs fw-bold">
                            South African ID numbers must be 13 digits and match your birth date and gender.
                        </small>

                        <!-- Country of Birth -->
                        <label for="client_birth_country" class="fw-bold text-xs text-start d-block mt-3">Country of Birth <span
                            class="text-danger">*</span></label>
                        <select v-model="client_birth_country" class="form-select rounded-small shadow-sm w-100"
                            id="client_birth_country" required>
                            <option value="" disabled selected>Select country of birth</option>
                            <option v-for="option in country_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_birth_country" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_birth_country }}
                        </small>
    
                        <!-- Mobile Contract Type -->
                        <label for="mobile_contract_type" class="fw-bold text-xs text-start d-block mt-3">Mobile Contract
                            Type
                            <span class="text-danger">*</span></label>
                        <select v-model="mobile_contract_type" class="form-select rounded-small shadow-sm w-100"
                            id="mobile_contract_type" required>
                            <option value="" disabled selected>Select contract type</option>
                            <option v-for="option in mobile_contract_type_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.mobile_contract_type" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.mobile_contract_type }}
                        </small>
    
                        <!-- Preferred Contact Method -->
                        <label for="contact_method" class="fw-bold text-xs text-start d-block mt-3">Preferred Contact Method
                            <span class="text-danger">*</span></label>
                        <select v-model="contact_method" class="form-select rounded-small shadow-sm w-100"
                            id="contact_method" required>
                            <option value="" disabled selected>Select preferred contact method</option>
                            <option v-for="option in contact_method_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.contact_method" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.contact_method }}
                        </small>
                    </div>

                    <!-- Additional Information Section -->
                    <div class="mb-4 p-3 border rounded shadow-sm">
                        <h5 class="fw-bold">Additional Information</h5>

                        <!-- Foreign Affiliation -->
                        <label class="fw-bold text-xs text-start d-block">Do you have any foreign birthplace, nationality,
                            citizenship or tax obligation? <span class="text-danger">*</span></label>
                        <div class="d-flex mt-2 text-xs">
                            <div class="form-check me-4">
                                <input v-model="client_foreign_affiliation_ind" class="form-check-input" type="radio"
                                    name="foreign_affiliation" id="foreign_yes" value="YES"
                                    @change="handle_client_foreign_affiliation_ind" />
                                <label class="form-check-label" for="foreign_yes">Yes</label>
                            </div>
                            <div class="form-check">
                                <input v-model="client_foreign_affiliation_ind" class="form-check-input" type="radio"
                                    name="foreign_affiliation" id="foreign_no" value="NO"
                                    @change="handle_client_foreign_affiliation_ind" />
                                <label class="form-check-label" for="foreign_no">No</label>
                            </div>
                        </div>
                        <small v-if="error_messages.client_foreign_affiliation_ind" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_foreign_affiliation_ind }}
                        </small>

                        <!-- Correspondence Language -->
                        <label for="client_correspondence_language" class="fw-bold text-xs text-start d-block mt-3">Correspondence Language <span class="text-danger">*</span></label>
                        <select v-model="client_correspondence_language" class="form-select rounded-small shadow-sm w-100" id="client_correspondence_language" required>
                            <option value="" disabled selected>Select correspondence language</option>
                            <option v-for="option in language_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_correspondence_language" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_correspondence_language }}
                        </small>

                        <!-- Home Language -->
                        <label for="client_home_language" class="fw-bold text-xs text-start d-block mt-3">Home Language <span class="text-danger">*</span></label>
                        <select v-model="client_home_language" class="form-select rounded-small shadow-sm w-100" id="client_home_language" required>
                            <option value="" disabled selected>Select home language</option>
                            <option v-for="option in language_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_home_language" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_home_language }}
                        </small>

                        <!-- Ethnic Group -->
                        <label for="client_ethnic_group" class="fw-bold text-xs text-start d-block mt-3">Ethnic Group <span class="text-danger">*</span></label>
                        <select v-model="client_ethnic_group" class="form-select rounded-small shadow-sm w-100" id="client_ethnic_group" required>
                            <option value="" disabled selected>Select ethnic group</option>
                            <option v-for="option in ethnic_group_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_ethnic_group" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_ethnic_group }}
                        </small>

                        <!-- Education Level -->
                        <label for="client_education_level" class="fw-bold text-xs text-start d-block mt-3">Education Level <span class="text-danger">*</span></label>
                        <select v-model="client_education_level" class="form-select rounded-small shadow-sm w-100" id="client_education_level" required>
                            <option value="" disabled selected>Select education level</option>
                            <option v-for="option in education_level_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_education_level" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_education_level }}
                        </small>
                    </div>

                    <!-- Next of Kin Section -->
                    <div class="mb-4 p-3 border rounded shadow-sm">
                        <h5 class="fw-bold">Next of Kin Information</h5>

                        <!-- Next of Kin First Name -->
                        <label for="relative_first_name" class="fw-bold text-xs text-start d-block">First Name <span
                                class="text-danger">*</span></label>
                        <input v-model="relative_first_name" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="relative_first_name" placeholder="Enter first name" maxlength="50" required />
                        <small v-if="error_messages.relative_first_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.relative_first_name }}
                        </small>

                        <!-- Next of Kin Last Name -->
                        <label for="relative_last_name" class="fw-bold text-xs text-start d-block mt-3">Last Name <span
                                class="text-danger">*</span></label>
                        <input v-model="relative_last_name" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="relative_last_name" placeholder="Enter last name" maxlength="50" required />
                        <small v-if="error_messages.relative_last_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.relative_last_name }}
                        </small>

                        <!-- Next of Kin Mobile Number -->
                        <label for="relative_mobile" class="fw-bold text-xs text-start d-block mt-3">Mobile Number <span
                                class="text-danger">*</span></label>
                        <input v-model="relative_mobile_number" type="text"
                            class="form-control rounded-small shadow-sm w-100" id="relative_mobile"
                            placeholder="Enter mobile number" @input="('relative_mobile_number')"
                            required />
                        <small v-if="error_messages.relative_mobile_number" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.relative_mobile_number }}
                        </small>

                        <!-- Relationship to Next of Kin -->
                        <label for="relative_relation" class="fw-bold text-xs text-start d-block mt-3">What is your
                            relationship
                            to your next of kin? <span class="text-danger">*</span></label>
                        <select v-model="relative_relation" class="form-select rounded-small shadow-sm w-100"
                            id="relative_relation" required>
                            <option value="" disabled selected>Select relationship</option>
                            <option v-for="option in relative_relation_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.relative_relation" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.relative_relation }}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mb-3 mt-4">
            <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
                @click="submit_personal_details" :disabled="!client_category">
                Continue
            </button>
        </div>
    </div>
</div>